// extracted by mini-css-extract-plugin
module.exports = {"off":"animate_off__wNP_X","up":"animate_up__piY6r","down":"animate_down__Ol0uv"};